import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';

function Privacy() {
  return (
    <StaticPage>
      <h1>Datenschutz</h1>
      <br />
      <small>Version 1, gültig ab 1. Februar 2016</small>
      <p>
        Mit dieser Datenschutzerklärung, die integrierter Bestandteil der
        Allgemeinen Geschäftsbedingungen der Ganz digital GmbH ist, verpflichtet
        sich die Ganz digital GmbH zu einem verantwortungsbewussten Umgang mit
        Ihren Personendaten. Die Sicherheit und der Schutz Ihrer persönlichen
        Daten haben bei Ganz digital GmbH und auf Webseite www.triff.app und in
        der triff App Priorität.
      </p>

      <h2>1. Umgang mit Personendaten</h2>
      <p>
        Wir geben Ihre Personendaten nicht an Dritte weiter, es sei denn, wir
        seien hierzu durch das Gesetz verpflichtet, oder Sie hätten gemäss den
        folgenden Ziffern eingewilligt. Nicht als Dritte gelten verbundene
        Unternehmen und Gruppengesellschaften im direkten Umfeld der Ganz
        digital GmbH.
      </p>

      <h2>2. Übertragung von Zahlungsinformationen</h2>
      <p>
        Abgefragte Daten, auch Kreditkartendaten, werden stets verschlüsselt
        (SSL- Verschlüsselung) übermittelt.
      </p>

      <h2>3. Definition von Personendaten</h2>
      <p>
        Als personenbezogene Daten gelten gemäss dem schweizerischen
        Bundesgesetz über den Datenschutz alle Daten, die sich alleine oder in
        Kombination auf eine bestimmte oder bestimmbare Person beziehen. Dazu
        gehören beispielsweise Ihr Name, Ihre Adresse, Ihr Geburtsdatum, Ihr
        Kennwort, Ihre E-Mail-Adresse, die beim Besuch unserer Webseiten für uns
        sichtbare Internet-Adresse (IP-Adresse) Ihres Computers sowie unsere
        Aufzeichnungen über Ihre Angebote und Buchungen und die von Ihnen
        getätigten Aktivitäten in der triff App. Diese Datenschutzerklärung
        erfasst sowohl historische als auch zukünftige Daten.
      </p>

      <h2>4. Grundsatz</h2>
      <p>
        Indem Sie Mitglied bei triff werden, willigen Sie ein, dass wir und die
        von uns beigezogenen Hilfspersonen und Dienstleister Ihre Personendaten
        für die Begründung und Verwaltung Ihres Mitgliedsverhältnisses sowie zur
        Durchführung und Abwicklung Ihrer über die Webseite www.triff.app und in
        der triff App angebahnten Geschäfte bearbeiten. Als Hilfspersonen und
        Dienstleister setzen wir sowohl Partner aus dem In- und Ausland ein, die
        u.a. für uns Server- und Backupinfrastruktur betreiben. Bei der Auswahl
        unserer Hilfspersonen und Dienstleister achten wir besonders darauf,
        dass allfällig übermittelte Personendaten anonymisiert und
        ausschliesslich im Umfang des jeweiligen Vertragszweckes bearbeitet und
        nicht an Dritte weitergegeben werden.
      </p>

      <h2>5. Ihre Nutzungsdaten im Besonderen</h2>
      <p>
        Mit dem Besuch von www.triff.app oder der triff App willigen Sie ein,
        dass wir Ihre Surfdaten im Zusammenhang mit der Benutzung von
        www.margr.it unter Zuhilfenahme elektronischer Hilfsmittel erheben,
        verarbeiten und auch nutzen. Wir nutzen auch Dienste Dritter zur Analyse
        Ihres Surfverhaltens um eine qualitativ hochwertige, schnelle und
        sichere Nutzererfahrung zu gewährleisten. Indem Sie www.margr.it
        besuchen, willigen Sie ein, dass wir insbesondere die nachfolgend unter
        Ziffer 6 und 7 genannten Technologien einsetzen, um Ihr Surfverhalten
        beim Besuch unserer Webseiten zu erfassen und Ihnen zuzuordnen.
      </p>

      <h2>6. Cookies und Zählpixel</h2>
      <p>
        Auf unseren Webseiten nutzen wir sogenannte „Cookies“ und „Zählpixel“.
        Ein Cookie ist ein kleines Datenpaket, welches vom Webserver an Ihren
        Browser gesendet und auf der Festplatte Ihres Computers gespeichert
        wird. Bei einem Zählpixel handelt es sich um eine kleine Bilddatei, die
        für Sie nicht sichtbar auf der Webseite implementiert ist und es
        ermöglicht anonymisierte,statistische Nutzungsdaten wie beispielsweise
        die Auswertung des Besucherverkehrs zu erfassen. Häufig werden Zählpixel
        in Verbindung mit Cookies verwendet und dienen statistischen
        Auswertungen. Speicherung von Cookies widersprechen Sie haben die
        Möglichkeit, Ihren Computer so einzustellen, dass er alle Cookies
        akzeptiert, Ihnen die Einrichtung eines Cookies meldet oder die Annahme
        aller Cookies bzw. Drittanbieter-Cookies verweigert. Zudem können Sie in
        Ihren Browsereinstellungen die Cookies jederzeit manuell löschen. Bitte
        beachten Sie, dass Ihnen bei einer Cookie-Deaktivierung bestimmte auf
        Ihre Person zugeschnittene Dienstleistungen nicht erbracht werden
        können. Dementsprechend können Sie möglicherweise nicht alle auf
        www.triff.app gebotenen Funktionen in vollem Umfang nutzen.
      </p>

      <h2>7. Web-Analyse</h2>
      <p>
        Die Ganz digital GmbH nutzt auf www.triff.app Web-Analyse Dienste, die
        aufzeigen, wie die einzelnen Webseiten genutzt werden. Diese
        Informationen verwenden wir, um unser Angebot zu verbessern und zu
        optimieren.
        <h3>Google Analytics</h3>
        <p>
          Google Analytics ist eine Dienstleistung von Google Inc. ("Google").
          Zwecks Erbringung der Dienstleistung verwendet Google Cookies, die auf
          Ihrem Datenträger gespeichert werden. Grundsätzlich werden die
          erfassten Daten an einen Server von Google in den USA übermittelt,
          wobei die IP-Adressen mittels IP- Anonymisierung anonymisiert werden,
          so dass eine Zuordnung nicht möglich ist. Ferner nimmt Google am
          „Safe-Harbor“ Abkommen des Handelsministeriums der USA mit der Schweiz
          und der Europäischen Union teil und verpflichtet sich, die darin
          festgehaltenen Datenschutzgrundsätze einzuhalten.
        </p>
        <h3>Verwendung weiterer Web-Analyse-Tools</h3>
        <p>
          Wir behalten uns unter Beachtung geltender Datenschutzgesetze vor,
          weitere, in der Funktionsweise ähnliche, Web-Analyse-Tools
          einzusetzen.
        </p>
        <h2>8. Veröffentlichung von Mitgliedsnamen, Wohnort, Bewertungen</h2>
        <p>
          Indem Sie Mitglied bei triff werden, willigen Sie ein, dass wir Ihren
          Mitgliedsnamen, den mit dem Mitgliedsnamen verbundenen Wohnort / Sitz,
          das Anmeldedatum, das Bewertungsprofil sowie die von Ihnen für andere
          Mitglieder hinterlassenen Bewertungskommentare allen Besuchern in der
          triff app öffentlich einsehbar sein können.
        </p>
        <h2>9. Veröffentlichung von Angeboten in der triff App</h2>
        <p>
          Sie stimmen sodann der Veröffentlichung von Angaben zu, die Sie bei
          der Erstellung eines Angebots oder im Rahmen der „Fragen &
          Antworten“-Funktion oder der Bewertungsfunktion eingeben. Darüber
          hinaus erklären Sie sich damit einverstanden, dass Ihr Name sowie die
          Adresse der Lokalität der Aktivität je nach gewählter Einstellung
          sichtbar sein können, wenn Sie eine Aktivität in der triff App
          anbieten und dass bei Angeboten Ihr Name ersichtlich ist. Wir können
          keine Verantwortung dafür übernehmen, wenn Dritte (zum Beispiel
          Betreiber von Suchmaschinen) die von Ihnen veröffentlichten
          Informationen im Internet weiterverbreiten.
        </p>
        <h2>10. Veröffentlichung von Beiträgen in Diskussionsforen</h2>
        <p>
          Bei der Verwendung von Diskussionsforen in der triff App willigen Sie
          ein, dass alle von Ihnen zugänglich gemachten Angaben sowie Ihr
          Benutzernamen von Dritten eingesehen werden können. Personenbezogene
          Daten sowie sonstige Angaben, die Sie diesen Foren zur Verfügung
          stellen, können von Dritten gelesen, gesammelt, weitergeleitet oder
          zur Übermittlung unaufgeforderter Mitteilungen an Sie verwendet
          werden. Die Ganz digital GmbH haftet nicht für personenbezogene und
          sonstige Angaben, die Sie in diesen Foren machen.
        </p>
        <h2>11. Anderweitige Veröffentlichung von Angeboten</h2>
        <p>
          Wir sind befugt, Angebote und die damit zusammenhängenden, in der
          triff App veröffentlichten Informationen auf anderen Plattformen sowie
          in anderen Medien (wie z.B. Zeitungen), allenfalls in angepasster
          Form, zu veröffentlichen.
        </p>
        <h2>12. Übermittlung von Kontaktdaten nach Vertragsschluss</h2>
        <p>
          Indem Sie Mitglied bei triff werden, willigen Sie ein, dass wir die
          hinterlegten Kontaktdaten und einen von Ihnen zu diesem Zweck
          eingegeben Text an den jeweiligen Vertragspartner zum Zwecke der
          Vertragsabwicklung übermitteln.
        </p>
        <h2>13. Nutzung zu Werbezwecken</h2>
        <p>
          Indem Sie Mitglied bei triff werden, willigen Sie ein, dass wir Ihre
          personenbezogenen Daten für Marketing-Massnahmen wie z.B. den Versand
          von E- Mails mit allgemeinen Informationen oder werbendem Charakter
          (Newsletter, E-Mails zu Informationszwecken) verarbeiten und nutzen.
          Wir dürfen die Daten auch an Hilfspersonen im In- und Ausland sowie
          verbundene Unternehmen und Gruppengesellschaften weiter geben, die für
          uns selber werben. Diese verpflichten sich vertraglich zur
          Nichtweitergabe Ihrer Personendaten. Auf Ihren Wunsch verzichten wir
          auf die Verwendung Ihrer Daten zu Werbezwecken. Sie können jederzeit
          eine entsprechende E-Mail an hallo@margr.it senden. Zudem finden Sie
          in jedem Newsletter einen direkten Abmelde-Link.
        </p>
        <h2>14. Links</h2>
        <p>
          Die Webseite www.triff.app oder die App triff kann auch Links auf
          Webseiten Dritter enthalten. Die Ganz digital GmbH haftet weder für
          die Datenschutzerklärung noch für die Sammlung und Verwendung
          persönlicher Daten noch für die Inhalte auf diesen Webseiten. Bei
          Nutzung eines Links zu einer anderen Webseite sollten Sie daher die
          für diese Website geltende Datenschutzrichtlinien sorgfältig lesen.
        </p>
        <h2>15. Social-Media-Plugins</h2>
        <p>
          Auf der Webseite www.triff.app und in der triff App sind Funktionen
          (sog. Plugins) verschiedener Drittanbieter von Social Media
          Plattformen (wie Facebook, Twitter, Google+) eingebunden. Diese
          Plugins ermöglichen es den Besuchern, Inhalte in sozialen Netzwerken
          zu teilen. Erscheint ein Plugin beim Surfen auf der Webseite (z.B
          "Gefällt-mir-Button" von Facebook), wird automatisch eine Verbindung
          zu den Servern dieser Webseite hergestellt. Dabei können Daten über
          Ihren Besuch auf triff an diesen Drittanbieter übermittelt werden. Ist
          der Besucher gleichzeitig im Netzwerk dieses Drittanbieters
          angemeldet, kann der Besuch der triff App seinem Netzwerk- Konto (z.B.
          Facebook-Account) zugeordnet werden. Die Ganz digital GmbH hat keinen
          Einfluss auf Art und Weise dieser Datenübermittlung. Zweck und Umfang
          der Datenerhebung und die weitere Verarbeitung und Nutzung der Daten
          durch Ihren Social-Media-Anbieter sowie Ihre diesbezüglichen Rechte
          und Einstellungsmöglichkeiten zum Schutz Ihrer Privatsphäre entnehmen
          Sie bitte den Datenschutzhinweisen dieses Anbieters.
        </p>
        <h2>
          16. Bearbeitung und Offenlegung im Zusammenhang mit betrügerischen
          Handlungen / Justiz- und Verwaltungsbehörden
        </h2>
        <p>
          Indem Sie Mitglied bei triff werden, willigen Sie ein, dass wir,
          soweit es im Einzelfall erforderlich ist, bei Vorliegen plausibler
          Anhaltspunkte diejenigen Personendaten erheben, verarbeiten, nutzen
          und bekannt geben, die zum Aufdecken sowie Unterbinden von in
          betrügerischer Absicht eingestellten Angeboten und sonstiger
          rechtswidriger oder vertragswidriger Inanspruchnahme von www.margr.it
          erforderlich sind. Zudem können wir aufgrund gerichtlicher oder
          verwaltungsbehördlicher Anfrage (z.B. Auskunftsbegehren) im
          Zusammenhang mit einem Ermittlungs- oder Verwaltungsverfahrens oder
          wegen eines Verdachts einer Straftat oder einer rechtswidrigen
          Handlung dazu angehalten werden, Personendaten offen zu legen.
        </p>
        <h2>
          17. Speicherung und Verwendung nach Durchführung von Angeboten oder
          nach Beendigung Ihrer Mitgliedschaft
        </h2>
        <p>
          Mit der Begründung Ihrer Mitgliedschaft willigen Sie ein, dass die
          Daten der Ihren Benutzernamen betreffenden Angeboten auch nach Ablauf
          der Angebotsdauer in der triff App für eine limitierte Dauer angezeigt
          werden. Sie stimmen sodann der Speicherung und Verwendung Ihrer Daten
          zu diesen Zwecken über die Beendigung der Mitgliedschaft hinaus zu.
          Insbesondere weisen wir darauf hin, dass Ihre erhaltenen und
          abgegebenen Bewertungen weiterhin einsehbar bleiben und dass
          gesetzliche Datenaufbewahrungspflichten bestehen.
        </p>
        <h2>18. Datensicherheit</h2>
        <p>
          Wir bedienen uns geeigneter technischer und organisatorischer
          Sicherheitsmassnahmen, um Ihre bei uns gespeicherten persönlichen
          Daten gegen Manipulation, teilweisen oder vollständigen Verlust und
          gegen unbefugten Zugriff Dritter zu schützen. Unsere
          Sicherheitsmassnahmen werden entsprechend der technologischen
          Entwicklung fortlaufend verbessert. Auch den unternehmensinternen
          Datenschutz nehmen wir sehr ernst. Unsere Mitarbeiter und die von uns
          beauftragten Dritten sind von uns zur Verschwiegenheit und zur
          Einhaltung der datenschutzrechtlichen Bestimmungen verpflichtet
          worden.
        </p>
        <h2>19. Auskunfts- und Löschungsrecht</h2>
        <p>
          Sie haben das Recht, jederzeit Auskunft über die von uns über Sie
          gespeicherten Personendaten zu erhalten. Des Weiteren können Sie
          verlangen, dass wir Ihre Personendaten berichtigen, ergänzen oder
          gänzlich löschen. Bitte beachten Sie, dass einem Löschungsantrag
          gesetzliche Aufbewahrungspflichten gegenügerstehen können. Auskunft-
          und Löschungsbegehren richten Sie bitte per Mail an hallo@margr.it.
        </p>
        <h2>20. Änderung dieser Datenschutzerklärung</h2>
        <p>
          Die Ganz digital GmbH behält sich das Recht vor, diese
          Datenschutzerlärung jederzeit zu überarbeiten, zu ändern oder in
          sonstiger Weise zu ergänzen. Über Änderungen, Ergänzungen oder
          Überarbeitungen informieren wir Sie jeweils mit einer entsprechenden
          Mitteilung über E-Mail oder über unseren Newsletter. Ihre fortgesetzte
          Nutzung der triff App gilt als Ihr Einverständnis mit allen
          Änderungen.
        </p>
        <p>
          Ganz digital GmbH
          <br />
          Version 2, 14. Februar 2019
        </p>
      </p>
    </StaticPage>
  );
}

export default Privacy;
